'use strict';

$(document).ready(function () {
    $('form.trackorder').on('submit', function(e) {
        e.preventDefault();
        let url = $(this).attr('action');
        $.ajax({
            type: 'GET',
            url: url,
            dataType: 'html',
            data: $(this).serialize()
        }).then(function(res) {
            let response = JSON.parse(res);
            document.location.href = response.redirectUrl;
        }).catch((err) => {
            let error = JSON.parse(err.responseText);
            toastr.error(error.errorMsg);
        });
    })
})
